import React from 'react';
import { Grid, InputAdornment, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { css } from '@emotion/react';
import { isNumber } from 'lodash';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import { Body1, H1 } from './blocks';
import QboTagField from './QboTagField';
import { isRateClassCell } from './rateUtils';

// Per-unit rates by rate class (rows) × the service level's base-rate bands (columns),
// persisted as `type` rows keyed by dimensions.rate_class. The QBO tag applies to existing
// rows, so set rates before tagging.
const RateClassGrid = ({
    type,
    rateClasses,
    rows,
    columns,
    serviceLevelId,
    baseRatesAxis,
    getHeader,
    callbacks,
    qbo_tags,
}) => (
    <>
        <Grid
            container
            css={css`
                align-items: center;
                margin-bottom: 12px;
            `}
        >
            <H1>Rate Class Rates</H1>
            <QboTagField
                options={qbo_tags}
                value={rows?.[0]?.qbo_tag}
                onCommit={(qbo) =>
                    callbacks.updateQBO({
                        qbo,
                        types: [type],
                        ...(serviceLevelId ? { service_level_id: serviceLevelId } : {}),
                    })
                }
                css={css`
                    width: 200px;
                    margin-left: 24px;
                `}
            />
        </Grid>
        {rateClasses.length === 0 ? (
            <Body1
                css={css`
                    margin-bottom: 24px;
                `}
            >
                No rate classes yet. Set a rate class on SKUs under SKU&apos;s / Services to price them here.
            </Body1>
        ) : (
            <Table
                css={css`
                    margin-bottom: 24px;
                `}
            >
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <Body1>Rate class</Body1>
                        </TableCell>
                        {columns.map((col) => (
                            <TableCell key={`rc-header-${col.subregion_id || col.min}`}>
                                <Body1>{getHeader(col, baseRatesAxis)}</Body1>
                            </TableCell>
                        ))}
                    </TableRow>
                    {rateClasses.map((rateClass) => (
                        <TableRow key={rateClass}>
                            <TableCell>
                                <Body1>{rateClass}</Body1>
                            </TableCell>
                            {columns.map((col) => {
                                const cell = (rows || []).find((row) =>
                                    isRateClassCell(row, {
                                        rate_class: rateClass,
                                        min: col.min,
                                        subregion_id: col.subregion_id,
                                        service_level_id: serviceLevelId,
                                    })
                                );
                                return (
                                    <TableCell key={`rc-${rateClass}-${col.subregion_id || col.min}`}>
                                        <CurrencyTextField
                                            size="small"
                                            value={isNumber(cell?.rate) ? cell.rate : ''}
                                            onChange={(_, val) =>
                                                callbacks.setRateClassRate({
                                                    type,
                                                    rate_class: rateClass,
                                                    min: col.min,
                                                    max: col.max,
                                                    subregion_id: col.subregion_id,
                                                    service_level_id: serviceLevelId,
                                                    rate: val,
                                                })
                                            }
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                endAdornment: <InputAdornment position="end">/unit</InputAdornment>,
                                            }}
                                            css={css`
                                                width: 150px;
                                            `}
                                        />
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        )}
    </>
);

export default RateClassGrid;
